
const HOST_LOCAL = process.env.VUE_APP_API_URL || 'http://localhost:1337';
let obj = {
    HOST : HOST_LOCAL,
    NONE_CONNECT_UGS: false,
}

module.exports = obj;
